import { useSelector } from "react-redux";
import ReusableDatagrid from "../components/ReusableDatagrid";

const columnsConfig = [
  {
    field: "agentAttorneyName",
    headerName: "Attorney Name",
    width: 240,
    placeholder: "Enter Attorney Name",
  },
  {
    field: "familyNo",
    headerName: "Family No(s)",
    width: 220,
    placeholder: "Enter Family No(s)",
  },
  {
    field: "notes",
    headerName: "Notes",
    width: 420,
    placeholder: "Enter Notes",
  },
];

const AttorneyPreferences = ({ mode }) => {
  const savedData = useSelector((state) => state.kotClient.attorneyPreferences);
  return <ReusableDatagrid title="Attorney Preferences" columnsConfig={columnsConfig} initialRows={savedData} section={"attorneyPreferences"} mode={mode} />;
};

export default AttorneyPreferences;
